// Messages reducer
const ADD_MESSAGE = `ticket/messages/ADD_MESSAGE`;
const FETCH_MESSAGES = `ticket/messages/FETCH_MESSAGES`;

export const ticketMessagesReducer = (state = [], action = {}) => {
  switch (action.type) {
    case ADD_MESSAGE:
      return [...state, action.payload];

    case FETCH_MESSAGES:
      return action.payload;

    default:
      return state;
  }
};

export const addMessage = (ticket) => ({
  type: ADD_MESSAGE,
  payload: ticket,
});
